var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSearchFill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9032 20.7319C14.3336 24.3918 7.64473 24.1037 3.40877 19.8678C-1.13626 15.3228 -1.13626 7.9538 3.40877 3.40877C7.9538 -1.13626 15.3228 -1.13626 19.8678 3.40877C24.1037 7.64473 24.3918 14.3336 20.732 18.9032L29.6212 27.7925C30.1262 28.2975 30.1262 29.1162 29.6212 29.6212C29.1162 30.1262 28.2975 30.1262 27.7925 29.6212L18.9032 20.7319ZM5.23755 18.039C1.70253 14.504 1.70253 8.77258 5.23755 5.23755C8.77258 1.70253 14.504 1.70253 18.039 5.23755C21.5714 8.76998 21.574 14.4956 18.0468 18.0312C18.0442 18.0338 18.0416 18.0364 18.039 18.039C18.0364 18.0416 18.0338 18.0442 18.0312 18.0468C14.4956 21.574 8.76999 21.5714 5.23755 18.039Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearchFill);
export default __webpack_public_path__ + "static/media/icon_search_fill.f406d7a4e02a283bd4582a2d4389cac9.svg";
export { ForwardRef as ReactComponent };